import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveSeoMeta } from './seoData';
import { SITE_URL } from './site';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function SeoManager() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'pt').split('-')[0];

  useEffect(() => {
    const meta = resolveSeoMeta(pathname, t('meta_title_home'), t('meta_desc_home'), lang);

    document.title = meta.title;
    upsertMeta('name', 'description', meta.description);
    upsertMeta('name', 'keywords', meta.keywords);
    upsertCanonical(`${SITE_URL}${meta.canonicalPath}`);

    upsertMeta('property', 'og:title', meta.title);
    upsertMeta('property', 'og:description', meta.description);
    upsertMeta('property', 'og:url', `${SITE_URL}${meta.canonicalPath}`);
    upsertMeta('property', 'og:type', meta.ogType);
    upsertMeta('property', 'og:locale', meta.ogLocale);
    upsertMeta('property', 'og:image', meta.ogImage);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', meta.title);
    upsertMeta('name', 'twitter:description', meta.description);
    upsertMeta('name', 'twitter:image', meta.ogImage);
  }, [pathname, t, lang]);

  return null;
}